import { getEnabledSwitchActions } from '@/utils/common/tableActions'

export default {
  data () {
    return {
      singleActions: [
        // 启用禁用
        ...getEnabledSwitchActions(this, undefined, ['bill_analysis_alarms_perform_enable', 'bill_analysis_alarms_perform_disable'], {
          metas: [
            (obj) => {
              const ret = {
                validate: !obj.enabled,
              }
              return ret
            },
            (obj) => {
              const ret = {
                validate: obj.enabled,
              }
              return ret
            },
          ],
          resourceName: this.$t('bill.analysis_cost_alarm'),
        }),
        {
          label: this.$t('common.more'),
          actions: (obj) => {
            return [
              {
                label: this.$t('bill.check_immediately'),
                permission: 'bill_analysis_alarms_create',
                action: () => {
                  this.createDialog('BillAnalysisAlarmCheckDialog', {
                    vm: this,
                    list: this.list,
                    data: [obj],
                    columns: this.columns,
                    title: this.$t('bill.check_immediately'),
                    name: this.$t('bill.analysis_cost_alarm'),
                    onManager: this.onManager,
                  })
                },
                meta: () => {
                  return {
                    validate: obj.enabled,
                  }
                },
              },
              {
                label: this.$t('table.action.clone'),
                permission: 'bill_analysis_alarms_create',
                action: () => {
                  this.$router.push({
                    name: 'BillAnalysisAlarmCreate',
                    params: {
                      type: 'clone',
                      row: obj,
                    },
                  })
                },
              },
              {
                label: this.$t('table.action.modify'),
                permission: 'bill_analysis_alarms_update',
                action: () => {
                  this.$router.push({
                    name: 'BillAnalysisAlarmCreate',
                    params: {
                      type: 'update',
                      row: obj,
                    },
                  })
                },
              },
              {
                label: this.$t('common.delete'),
                permission: 'bill_analysis_alarms_delete',
                action: () => {
                  this.createDialog('DeleteResDialog', {
                    vm: this,
                    data: [obj],
                    columns: this.columns,
                    title: this.$t('common.delete'),
                    name: this.$t('bill.analysis_cost_alarm'),
                    onManager: this.onManager,
                  })
                },
              },
            ]
          },
        },
      ],
    }
  },
}
